/**
* @summary - Component that Provides Dialog Box 
* @author Yuvasri S
* @since 2024-05-28
*/
import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';

const CustomAlert = ({ open, onClose, onConfirm, title, content,cancelBtn, confirmBtn,onWidth = false,onRemovePadding = false }) => {
  const handleDialogClose = (event, reason) => {
    // Prevent closing the dialog if the reason is 'backdropClick'
    if (reason !== 'backdropClick') {
      onClose(event, reason);
    }
  };
  return (
    <Dialog
    sx={{
      "& .MuiDialog-paper": {
        width: onWidth ? "auto" : "30%",
        maxHeight: 500,
        padding: onRemovePadding ? "" : "10px 5px",
      },
    }}
    open={open}
    onClose={handleDialogClose}
  >
      <DialogTitle fontWeight={800}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
      
  {confirmBtn && (
          <Button variant="contained" onClick={onConfirm} >{confirmBtn}</Button>
        )}
          {cancelBtn && (
        <Button onClick={onClose}>{cancelBtn}</Button>
        )}



        {/* <Button onClick={onConfirm} color="primary">Ok</Button> */}
      </DialogActions>
    </Dialog>
  );
};

export default CustomAlert;
